import { render, staticRenderFns } from "./ModalTransferChatUser.vue?vue&type=template&id=1e7e4483"
import script from "./ModalTransferChatUser.vue?vue&type=script&lang=js"
export * from "./ModalTransferChatUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports